// Evenly spaced tick labels for a Slider's scale. One helper so every
// length slider is read off its own range instead of a hand-typed list.

export function evenTicks(min: number, max: number, count = 5): string[] {
  if (count < 2 || max <= min) return [String(min)];
  const step = (max - min) / (count - 1);
  return Array.from({ length: count }, (_, i) => String(Math.round(min + step * i)));
}

// The ONE clamp — drag, tick click and typed entry all land here, so a
// Slider's track and its number box cannot disagree.
export function snapToStep(value: number, min: number, max: number, step = 1): number {
  if (!Number.isFinite(value)) return min;
  const grid = step > 0 ? step : 1;
  const snapped = min + Math.round((value - min) / grid) * grid;
  return Math.min(max, Math.max(min, snapped));
}

// Step-grid snapped: a tick click lands only where dragging could.
export function tickValue(
  index: number,
  count: number,
  min: number,
  max: number,
  step = 1,
): number {
  if (count < 2 || max <= min) return min;
  return snapToStep(min + ((max - min) * index) / (count - 1), min, max, step);
}
